import axiosInstance from '../axiosInterceptor/axiosInstance'

const getBillingSummary = async (data) => {
  const { orgId } = data
  const url = `v1/orgs/${orgId}/billing/summary`
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getBillingSummary
